import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios';
import striptags from 'striptags';
import LazyLoad from 'react-lazy-load';

import _ from 'lodash'

class LatestBlogPosts extends React.Component {
  constructor() {
    super();
    this.state = {
      posts: []
    };
  }

  componentWillMount() {
    axios.get('/api/posts?limit=10')
      .then(response => {

        let validPosts = [];
        validPosts = response.data.filter((post) => {
          if (post.show_more && (post.type === 'AlbumPost' || post.type === 'DetailPost' || post.type === 'LieblingsalbumPost') ) {
            return post;
          }
        });

        this.setState({ posts: validPosts.slice(0, 3) });
      })
      .catch(error => {
        console.error(error);
      });
  }
  render() {
    return (
      this.state.posts.length > 0 &&
      <div className="latest-blog-posts" >
        {
          this.state.posts.map((post, index) =>
            <div className="latest-blog-post">
              <a key={post.id} href={`/posts/${post.slug}`}>
                <div className="latest-blog-post__image-container">
                  <LazyLoad offsetVertical={300}>
                    <img className="latest-blog-post__image" src={post.cloudfront_url} />
                  </LazyLoad>
                </div>
                <div className="latest-blog-post__text" dangerouslySetInnerHTML={{ __html: striptags(`${post.artist_name ? post.artist_name + ' - ' : ''}${post.title}`) }}>
                </div>
              </a>
            </div>
          )
        }
      </div>
    );
  }
}

export default LatestBlogPosts;